"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColors = {
    Primary: '#333',
    Secondary: '#4f4f4f',
    Neutral: '#707070',
    Disabled: '#bfbfbf',
    Error: '#c93a47',
    Valid: '#008057',
};
exports.IconFillColors = {
    Rest: '#666',
    Hover: '#333',
    Disabled: '#bfbfbf',
    Error: '#c93a47',
    Valid: '#008057',
    Warning: '#FECA56',
    Info: '#2979B2',
};
exports.TextFieldBorderColors = {
    Rest: '#cbcbcb',
    Disabled: '#bfbfbf',
    Hover: '#333',
    Error: '#c93a47',
    Valid: '#008057',
};
exports.InvertTextColors = {
    Primary: '#fff',
    Secondary: 'rgba(255, 255, 255, 0.56)',
    Netural: 'rgba(255, 255, 255, 0.56)',
    Disabled: 'rgba(255, 255, 255, 0.35)',
};
exports.InvertIconFillColors = {
    Rest: 'rgba(255, 255, 255, 0.5)',
    Hover: 'rgba(255, 255, 255, 0.8)',
    Disabled: 'rgba(255, 255, 255, 0.35)',
};
exports.InvertBorderColors = {
    Rest: 'rgba(255, 255, 255, 0.5)',
    Hover: '#fff',
    Disabled: 'rgba(255, 255, 255, 0.35)',
};
exports.TextFieldHoverColor = '#fafafa';
exports.InteractiveBorderColors = Object.freeze({
    borderColor: exports.TextFieldBorderColors.Rest,
    $nest: {
        '&:hover': { borderColor: exports.TextFieldBorderColors.Hover },
        '&:active': { borderColor: exports.TextFieldBorderColors.Hover },
        '&:disabled': { borderColor: "" + exports.TextFieldBorderColors.Disabled },
    }
});
exports.InvertInteractiveBorderColors = Object.freeze({
    borderColor: exports.InvertBorderColors.Rest,
    $nest: {
        '&:hover': { borderColor: exports.InvertBorderColors.Hover },
        '&:active': { borderColor: exports.InvertBorderColors.Hover },
        '&:disabled': { borderColor: "" + exports.InvertBorderColors.Disabled },
    }
});
//# sourceMappingURL=Colors.js.map